(function () {
  function initBundleBuilder() {
    var roots = document.querySelectorAll(".bb");
    if (!roots.length) return;

    roots.forEach(function (root) {
      if (root.dataset.bbInitialized === "true") return;
      root.dataset.bbInitialized = "true";

      var LIMIT = parseInt(root.dataset.bundleQty, 10) || 3;
      var BASE_PRICE_CENTS = parseInt(root.dataset.productPrice, 10) || 0;
      var BASE_PRICE_RUPEES = Math.round(BASE_PRICE_CENTS / 100);

      var state = {
        selected: []
      };

      var countEl = root.querySelector("[data-count]");
      var tabBadge = root.querySelector("[data-tab-badge]");
      var drawerList = root.querySelector("[data-drawer-list]");
      var ctaBtn = root.querySelector("[data-cta]");
      var ctaText = root.querySelector("[data-cta-text]");
      var presetBtn = root.querySelector("[data-preset-btn]");
      var presetLabel = root.querySelector("[data-preset-label]");
      var origPrice = root.querySelector("[data-orig-price]");
      var bdMrp = root.querySelector("[data-bd-mrp]");
      var cards = root.querySelectorAll(".bb__card");

      function formatRupee(val, isCents) {
        var num = isCents ? Math.round(val / 100) : val;
        return "₹" + Number(num).toLocaleString("en-IN");
      }

      function getCard(vid) {
        return root.querySelector('.bb__card[data-variant-id="' + vid + '"]');
      }

      function renderDrawer() {
        if (!drawerList) return;

        if (state.selected.length === 0) {
          drawerList.innerHTML =
            '<p class="bb__drawer-empty">No perfumes yet. Tap any card to add it to your box.</p>';
          return;
        }

        var html = "";
        state.selected.forEach(function (vid) {
          var card = getCard(vid);
          if (!card) return;

          var title = card.dataset.title || "";
          var type = card.dataset.type || "Eau De Parfum";
          var price = parseInt(card.dataset.price, 10) || 0;
          var img = card.dataset.img || "";

          html += '<div class="bb__drawer-item" data-drawer-vid="' + vid + '">';
          html += '<div class="bb__drawer-swatch">';
          if (img) {
            html += '<img src="' + img + '" alt="' + title + '" loading="lazy" />';
          }
          html += '</div>';
          html += '<div class="bb__drawer-details">';
          html += '<div class="bb__drawer-name">' + title + '</div>';
          html += '<div class="bb__drawer-worth">' + formatRupee(price, true) + ' worth</div>';
          html += '</div>';
          html +=
            '<button type="button" class="bb__drawer-rm" data-rm="' +
            vid +
            '" aria-label="Remove ' +
            title +
            '">';
          html +=
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
          html += "</button>";
          html += "</div>";
        });

        drawerList.innerHTML = html;

        drawerList.querySelectorAll("[data-rm]").forEach(function (rmBtn) {
          rmBtn.addEventListener("click", function (e) {
            e.stopPropagation();
            var vid = this.dataset.rm;
            deselect(vid);
          });
        });
      }

      function updatePickStates() {
        cards.forEach(function (card) {
          var vid = String(card.dataset.variantId || "").trim();
          var isSel = state.selected.indexOf(vid) !== -1;
          var isFull = state.selected.length >= LIMIT;

          card.classList.toggle("bb__card--selected", isSel);

          var btn = card.querySelector("[data-pick]");
          if (btn) {
            btn.setAttribute("aria-pressed", isSel ? "true" : "false");
            btn.disabled = !isSel && isFull;
          }
        });
      }

      function render() {
        var n = state.selected.length;
        var remaining = LIMIT - n;

        if (countEl) countEl.textContent = n + "/" + LIMIT;
        if (tabBadge) tabBadge.textContent = n;

        var tab = root.querySelector(".bb__tab");
        if (tab) {
          tab.classList.toggle("bb__tab--visible", n > 0);
        }
        var drawerToggle = document.getElementById("bb-drawer-toggle");
        if (n === 0 && drawerToggle && drawerToggle.checked) {
          drawerToggle.checked = false;
        }

        root.querySelectorAll("[data-dot]").forEach(function (dot, idx) {
          dot.classList.toggle("bb__dot--on", idx < n);
        });

        var totalMrp = state.selected.reduce(function (acc, vid) {
          var c = getCard(vid);
          if (!c) return acc;
          var compare = parseInt(c.dataset.compare, 10) || 0;
          var price = parseInt(c.dataset.price, 10) || 0;
          return acc + (compare > 0 ? compare : price);
        }, 0);

        if (bdMrp) {
          bdMrp.textContent = totalMrp > 0 ? formatRupee(totalMrp, true) : "—";
        }

        if (origPrice) {
          origPrice.textContent =
            totalMrp > 0 ? formatRupee(totalMrp, true) : formatRupee(BASE_PRICE_RUPEES, false);
        }

        if (ctaBtn) {
          ctaBtn.disabled = n < LIMIT;
        }

        if (ctaText) {
          if (n >= LIMIT) {
            ctaText.textContent = "BUY NOW";
          } else {
            ctaText.textContent = "ADD " + remaining + " MORE";
          }
        }

        updatePickStates();
        renderDrawer();
      }

      function select(vid) {
        vid = String(vid).trim();
        if (!vid) return;
        if (state.selected.length >= LIMIT) return;
        if (state.selected.indexOf(vid) !== -1) return;
        state.selected.push(vid);
        render();
      }

      function deselect(vid) {
        vid = String(vid).trim();
        var idx = state.selected.indexOf(vid);
        if (idx !== -1) {
          state.selected.splice(idx, 1);
          render();
        }
      }

      function toggle(vid) {
        vid = String(vid).trim();
        if (!vid) return;
        if (state.selected.indexOf(vid) !== -1) {
          deselect(vid);
          if(presetLabel.textContent == "Selected ✓") {
            presetLabel.textContent = "Select Now"; 
          }
        } else {
          select(vid);
        }
      }

      // Bind card clicks
      cards.forEach(function (card) {
        card.addEventListener("click", function (e) {
          var vid = this.dataset.variantId;
          toggle(vid);
        });

        var pickBtn = card.querySelector("[data-pick]");
        if (pickBtn) {
          pickBtn.addEventListener("click", function (e) {
            e.stopPropagation();
            var vid = card.dataset.variantId;
            toggle(vid);
          });
        }
      });

      // Synchronize drawer and breakdown popup scrims
      var drawerToggleEl = document.getElementById("bb-drawer-toggle");
      var breakdownToggleEl = document.getElementById("bb-breakdown-toggle");
      if (drawerToggleEl && breakdownToggleEl) {
        drawerToggleEl.addEventListener("change", function () {
          if (this.checked && breakdownToggleEl.checked) {
            breakdownToggleEl.checked = false;
          }
        });
        breakdownToggleEl.addEventListener("change", function () {
          if (this.checked && drawerToggleEl.checked) {
            drawerToggleEl.checked = false;
          }
        });
      }

      // Preset button ("Select Now" button - strictly selects admin-configured preset products)
      if (presetBtn) {
        presetBtn.addEventListener("click", function (e) { console.log('welcome');
          e.preventDefault();
          // rem
          if(presetLabel.textContent == "Selected ✓") {
            state.selected = [];
            render();
            if (presetLabel) { presetLabel.textContent = "Select Now"; }
            return;
          }
          
          var presetVariants = (this.dataset.presetVariants || "")
            .split(",")
            .map(function (v) {
              return v.trim();
            })
            .filter(Boolean);
          var presetProducts = (this.dataset.presetProducts || "")
            .split(",")
            .map(function (p) {
              return p.trim();
            })
            .filter(Boolean);

          state.selected = [];

          // 1. Select by admin-chosen preset variant IDs
          if (presetVariants.length > 0) {
            presetVariants.forEach(function (vid) {
              if (state.selected.length < LIMIT) {
                var card = root.querySelector('.bb__card[data-variant-id="' + vid + '"]');
                if (card) select(card.dataset.variantId);
              }
            });
          }

          // 2. Select by admin-chosen preset product IDs (if variants differed)
          if (state.selected.length < LIMIT && presetProducts.length > 0) {
            presetProducts.forEach(function (pid) {
              if (state.selected.length < LIMIT) {
                var card = root.querySelector('.bb__card[data-product-id="' + pid + '"]');
                if (card) select(card.dataset.variantId);
              }
            });
          }

          render();

          if (presetLabel) {
            var orig = presetLabel.textContent;
            presetLabel.textContent = "Selected ✓";
            setTimeout(function () {
              //presetLabel.textContent = orig;
            }, 1200);
          }
        });
      }

      // Buy Now -> Gokwik Checkout / Direct Checkout
      if (ctaBtn) {
        ctaBtn.addEventListener("click", function (e) {
          e.preventDefault();
          if (state.selected.length < LIMIT) return;

          var parentVariantId = root.dataset.variantId;
          if (!parentVariantId) {
            console.error("Parent product variant ID not found");
            return;
          }

          var parentStoreId = root.dataset.storeId || "";
          var parentTitle = root.dataset.productName || "Custom Bundle";
          var parentSku = root.dataset.sku || "";
          var parentVendor = root.dataset.vendor || "TMC";
          var parentProductId = root.dataset.productId || "";
          var parentVariantTitle = root.dataset.variantTitle || "Default Title";

          var uniwareItems = {
            items: [
              {
                id: parentStoreId,
                quantity: 1,
                varint_title: parentVariantTitle,
                origin_location: "",
                fulfillment_status: "",
                total_discount: "",
                gift_card: "",
                requires_shipping: "",
                total_discount_set: "",
                title: parentTitle,
                variant_id: parentVariantId,
                tax_lines: "",
                mrp: "",
                price: 0,
                grams: "",
                sku: parentSku,
                vendor: parentVendor,
                product_id: parentProductId,
                currency_code: "INR",
                fulfillable_quantity: "",
                fulfillment_service: "",
                taxable: "",
                discount_allocations: "",
                name: parentTitle,
                price_set: "",
                properties: '{"_product":"parent"}',
                duties: ""
              }
            ]
          };

          var props = {
            custom_flag: "bundle-builder",
            byob: true
          };

          var totalChildPrice = 0;
          state.selected.forEach(function (vid) {
            var c = getCard(vid);
            var price = c ? parseInt(c.dataset.price, 10) || 0 : 0;
            totalChildPrice += Math.round(price / 100);
          });

          state.selected.forEach(function (vid, idx) {
            var c = getCard(vid);
            var title = c ? c.dataset.title || "" : "";
            var sku = c ? c.dataset.sku || "" : "";
            var img = c ? c.dataset.img || "" : "";
            var pId = c ? c.dataset.productId || "" : "";
            var storeId = c ? c.dataset.storeId || "" : "";
            var vTitle = c ? c.dataset.variantTitle || "Default Title" : "";
            var vPrice = c ? parseInt(c.dataset.price, 10) || 0 : 0;
            var vPriceRupees = Math.round(vPrice / 100);

            var itemNum = idx + 1;
            props["Item " + idx] = title;
            props["sub_item_" + itemNum] = title + " x 1 :: " + img;

            var itemPriceFraction =
              totalChildPrice > 0
                ? ((vPriceRupees / totalChildPrice) * BASE_PRICE_RUPEES).toFixed(2)
                : (BASE_PRICE_RUPEES / LIMIT).toFixed(2);

            uniwareItems.items.push({
              id: storeId,
              quantity: 1,
              varint_title: vTitle,
              origin_location: "",
              fulfillment_status: "",
              total_discount: "",
              gift_card: "",
              requires_shipping: "",
              total_discount_set: "",
              title: title,
              variant_id: vid,
              tax_lines: "",
              mrp: "",
              price: itemPriceFraction,
              grams: "",
              sku: sku,
              vendor: "TMC",
              product_id: pId,
              currency_code: "INR",
              fulfillable_quantity: "",
              fulfillment_service: "",
              taxable: "",
              discount_allocations: "",
              name: title,
              price_set: "",
              properties: '{"_product":"child"}',
              duties: ""
            });
          });

          props["uniware_items"] = JSON.stringify(uniwareItems);

          var productItems = [
            {
              id: parseInt(parentVariantId, 10),
              quantity: 1,
              properties: props
            }
          ];

          // Gokwik Checkout Trigger
          if (typeof onBuyNowClick === "function") {
            onBuyNowClick(e, false, productItems);
          } else {
            ctaBtn.disabled = true;
            if (ctaText) ctaText.textContent = "Proceeding to Checkout…";

            fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ items: productItems })
            })
              .then(function (r) {
                if (!r.ok) throw new Error("Cart error");
                return r.json();
              })
              .then(function () {
                window.location.href = "/checkout";
              })
              .catch(function (err) {
                console.error(err);
                if (ctaText) ctaText.textContent = "Error – Try again";
                ctaBtn.disabled = false;
              });
          }
        });
      }

      render();

      // ============================================
      // INTRO SPOTLIGHT & PRICE DROP ANIMATION
      // ============================================
      var overlay =
        root.querySelector("[data-intro-overlay]") ||
        document.querySelector("[data-intro-overlay]");
      var bar = root.querySelector("[data-bar]");
      var finalPriceEl = root.querySelector("[data-final-price]");
      var origPriceEl = root.querySelector("[data-orig-price]");

      var startPrice =
        (finalPriceEl && parseInt(finalPriceEl.dataset.startPrice, 10)) ||
        BASE_PRICE_RUPEES ||
        599;

      var targetFinalPrice = finalPriceEl
        ? parseInt(finalPriceEl.dataset.finalPrice, 10) ||
          parseInt(finalPriceEl.textContent.replace(/[^0-9]/g, ""), 10) ||
          startPrice
        : startPrice;

      if (overlay && bar && finalPriceEl) {
        // Ensure overlay is at document.body level so it covers entire viewport without theme container clipping
        if (overlay.parentElement !== document.body) {
          document.body.appendChild(overlay);
        }

        overlay.style.display = "block";
        overlay.style.opacity = "1";

        // 1. Setup spotlight mode
        bar.classList.add("bar-glow");
        bar.classList.add("bb__bar--intro");

        if (origPriceEl) {
          origPriceEl.classList.remove("bb__orig-price--visible");
          origPriceEl.style.opacity = "0";
        }

        // 2. Ensure starting display price matches start price without jump
        finalPriceEl.textContent = "₹" + startPrice.toLocaleString("en-IN");

        var dismissed = false;
        function dismissIntro() {
          if (dismissed) return;
          dismissed = true;
          if (overlay) {
            overlay.style.opacity = "0";
          }
          bar.classList.remove("bar-glow");
          bar.classList.remove("bb__bar--intro");
          bar.style.borderTop = "1px solid #eaeaea";
          if (origPriceEl) {
            origPriceEl.classList.add("bb__orig-price--visible");
            origPriceEl.style.opacity = "1";
          }
          finalPriceEl.textContent = "₹" + Number(targetFinalPrice).toLocaleString("en-IN");
          setTimeout(function () {
            if (overlay) {
              overlay.style.display = "none";
            }
          }, 560);
        }

        // Allow quick tap to dismiss overlay
        overlay.addEventListener("click", dismissIntro);

        // 3. Start synchronized price drop countdown (500ms entrance settle)
        setTimeout(function () {
          if (dismissed) return;
          animatePriceDrop(
            finalPriceEl,
            startPrice,
            targetFinalPrice,
            1600,
            function onComplete() {
              if (dismissed) return;

              // A. Slide & fade in the strikethrough original price
              if (origPriceEl) {
                origPriceEl.classList.add("bb__orig-price--visible");
                origPriceEl.style.opacity = "1";
              }

              // B. After 700ms, smoothly dismiss dark overlay & spotlight glow
              setTimeout(function () {
                dismissIntro();
              }, 700);
            }
          );
        }, 500);
      } else if (origPriceEl) {
        origPriceEl.classList.add("bb__orig-price--visible");
        origPriceEl.style.opacity = "1";
      }
    });
  }

  // Smooth price drop counter with cubic easing (60-120fps native)
  function animatePriceDrop(element, startValue, targetValue, duration, onComplete) {
    if (!element) return;
    duration = duration || 1600;

    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);

      // Ease-out cubic deceleration
      var ease = 1 - Math.pow(1 - progress, 3);
      var currentVal = Math.round(startValue - (startValue - targetValue) * ease);

      element.textContent = "₹" + currentVal.toLocaleString("en-IN");

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        element.textContent = "₹" + Number(targetValue).toLocaleString("en-IN");
        if (typeof onComplete === "function") onComplete();
      }
    }

    requestAnimationFrame(step);
  }

  // Initialize immediately or on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBundleBuilder);
  } else {
    initBundleBuilder();
  }

  // Support Shopify Theme Editor live preview
  document.addEventListener("shopify:section:load", function (e) {
    if (e.target && e.target.querySelector(".bb")) {
      var bb = e.target.querySelector(".bb");
      if (bb) delete bb.dataset.bbInitialized;
      initBundleBuilder();
    }
  });
})();